export default function({
    settings = {},
    name,
    onChange
}) {

    return [
        {
            type: "InputPassword",
            data: {
                onChange,
                attrs: {
                    placeholder: "Введите пароль",
                    value: settings[name],
                    autocomplete:"one-time-code"
                }
            }
        }
    ]
}